import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { RxTemplate } from '@shared/rx-templates/rx-template.model';
import { ProcedureMap } from '@shared/models/procedure-map';
import { ISectionDirtyCheckService } from '@shared/models/section-dirty-check';
import { OrderQuery } from './state/order-query';
import { isDueDateVisibleForSendTo } from '@shared/services/sections-visibility.tokens';
import { RxTemplateService } from '@shared/rx-templates/rx-template.service';

@Injectable({ providedIn: 'root' })
export class DueDateDirtyCheckService implements ISectionDirtyCheckService {
	constructor(
		private readonly orderQuery: OrderQuery,
		private readonly rxTemplateService: RxTemplateService
	) {}

	willLoseDataFor$(targetTemplate: Readonly<RxTemplate>, _targetProcedureMap: ProcedureMap | null): Observable<boolean> {
		if (!isDueDateVisibleForSendTo(this.rxTemplateService.currentTemplate) || isDueDateVisibleForSendTo(targetTemplate)) {
			return of(false);
		}

		return of(this.orderQuery.getValue().dueDate != null);
	}
}
